import Cross from "../../../assets/icon/NewsIcons/MainAdmin/NewsCross";
import React, { useState, useEffect } from "react";
import { axiosReq, axiosReq2, axiosReqCustom } from "../../../commons/axiosReq";
import { useNavigate, Link } from "react-router-dom";
import Select from "react-select";
import axios from "axios";
import { apiUrlFaceSar, apiUrlWordCloudImageSar } from "../../../commons/inFormTypes";
import PhotoUpload from "../MainComponents/FileUpload";
import ClipLoader from "react-spinners/ClipLoader";

const AddModalFace = ({ setShowModal, title, buttonName, setRecheck, reCheck, data, type,names }) => {
  let navigate = useNavigate();
  const [snipper, setSnipper] = useState(false);
  const [showErrorModalStep1, setShowErrorModalStep1] = useState(false);
  const [error, setEroor] = useState();
  const [dataimage, setDataImage] = useState();
  const [files, setFiles] = useState();
  const [dataText, setDataText] = useState();
  const [person, setPerson] = useState(null);
  const [name, setName] = useState();
  const [hasimage, setHasImage] = useState(false);
    const [persons, setPersons] = useState([]);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: "#f1f5ff",
      borderRadius: 5,
      "&:hover": {
        borderColor: "#f1f5ff",
      },
      boxShadow: "none",
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#e8eeff",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#000",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#000",
      "&:hover": {
        backgroundColor: "#E64A19",
        color: "white",
      },
    }),
  };
 const GetPersons = async (name1) => {
        const tagsData =  await axiosReqCustom(apiUrlFaceSar+"persons?collection_name="+name1, "get");
        console.log(1234)
        console.log(tagsData)

        var tagArr = [];
        tagsData?.map((item) => {
            tagArr.push({ value: item.name+"-"+item.role, label: item.name+"-"+item.role })
        })
        setPersons(tagArr)
    }
  const handlePersonChange = (newValue) => {
    setPerson(newValue || []);
  };
const handleNameChange = (newValue) => {
  console.log(newValue.value)
    setName(newValue );
        GetPersons(newValue.value)

  };
  const [allValues, setAllValues] = useState({
    Name: "",
  });
  const [allValuesError, setAllValuesError] = useState({
    Name: false,
  });

  const blurHandler = (e) => {
    if (e.target && e.target.value === "") {
      setAllValuesError({ ...allValuesError, [e.target.name]: true });
    }
  };

  const changeHandler = (e) => {
    if (e.target) {
      const val = e.target.value;
      setAllValuesError({ ...allValuesError, [e.target.name]: val === "" });
      setAllValues({ ...allValues, [e.target.name]: val });
    }
  };

  const downloadImage = (base64Data, filename = "generated-image.png") => {
    const link = document.createElement("a");
    link.href = base64Data;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const editAdmin = async () => {
    setSnipper(true);
    try {
      if (!files) {
        setEroor("لطفا ابتدا یک فایل انتخاب کنید");
        setShowErrorModalStep1(true);
        return;
      }

      const formData = new FormData();
      formData.append("file", files, files.name);
      formData.append("collection_name",  name?.value);

      const { data, status } = await axios.post(apiUrlFaceSar + type, formData, {
        headers: {
          Authorization: `Bearer c2dffe2aa00a3f8b7d854279f4aaa1ff`,
          Accept: "application/json",
        },
      });

      if (status >= 200 && status < 300) {
        setDataText(data);
      } else {
        setEroor(data || "خطا در پردازش فایل");
        setShowErrorModalStep1(true);
      }
    } catch (err) {
      setEroor(
        err?.response?.data?.message ||
          err?.message ||
          "خطا در برقراری ارتباط با سرور"
      );
      setShowErrorModalStep1(true);
    } finally {
      setSnipper(false);
    }
  };

  const batch_detect = async () => {
    setSnipper(true);
    try {
          if(name.length==0){
     setEroor("لطفا ابتدا موجودیت را انتخاب کنید");
                setShowErrorModalStep1(true);
                setSnipper(false);

                return;
}
      if (!files) {
        setEroor("لطفا ابتدا یک فایل انتخاب کنید");
        setShowErrorModalStep1(true);
        return;
      }
  
      let per = [];
      person?.map((item) =>
        per.push({ role: item.value.split("-")[1], name: item.value.split("-")[0] })
      );

      const formData = new FormData();
      formData.append("file", files, files.name);
      formData.append("persons", JSON.stringify(per));
      formData.append("collection_name",  name?.value);
      // formData.append("Authorization",  "Bearer c2dffe2aa00a3f8b7d854279f4aaa1ff");

      const { data, status } = await axios.post(
        apiUrlFaceSar + type + "?return_image=" + hasimage,
        formData,
        {
          
          headers: { Accept: "application/json",Authorization: `Bearer c2dffe2aa00a3f8b7d854279f4aaa1ff`, },
        }
      );

      if (status >= 200 && status < 300) {
        console.log(data)
        if(data.length!=0){
            
            setDataImage(data);
        }else{
alert("داده ای دریافت نشد")
        }
      } else {
        setEroor(data || "خطا در پردازش فایل");
        setShowErrorModalStep1(true);
      }
    } catch (err) {
      setEroor(
        err?.response?.data?.message ||
          err?.message ||
          "خطا در برقراری ارتباط با سرور"
      );
      setShowErrorModalStep1(true);
    } finally {
      setSnipper(false);
    }
  };

  return (
    <>
      {/* Overlay */}
      <div className="fixed inset-0 z-50 flex items-start justify-center pt-5 overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
        <div className="relative w-[80%] sm:w-[80%] lg:w-[50%] my-5 mx-auto">
          {/* Modal Box */}
          <div
            className={`border-0 rounded-[20px] p-[25px] ${
              type == "batch_detect" && dataimage ? "mt-6" : "mt-5"
            } shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none max-h-[80vh] overflow-y-auto`}
          >
            <div className="flex justify-between items-center border-b-2 pb-[25px] border-borderGray">
              <p className="text-[15px] font-IRANYekanBold text-mainColor2">
                {title}
              </p>
              <button onClick={() => setShowModal(false)}>
                <Cross />
              </button>
            </div>
 <div className="mt-4">
                  <div className="flex">
                    <p className="text-[15px] font-IRANYekanExtra text-mainColor2 mb-1">
                      انتخاب موجودیت
                    </p>
                    <p className="text-[#ff0000]">*</p>
                  </div>
                  <Select
                    options={names}
                    // isMulti
                    value={name}
                    onChange={handleNameChange}
                    placeholder="انتخاب کنید"
                    styles={customStyles}
                    className="text-[12px] font-IRANYekanNormal focus:outline-lightGray border-[1px] border-borderGray rounded-[5px]"
                  />
                </div>
            {/* Response data display */}
            {dataText &&
              dataText.map((item, index) => (
                <div key={index}>
                  <p className="text-[15px] font-IRANYekanBold text-mainColor2">
                    نام: {item?.name}
                  </p>
                  <p className="text-[15px] font-IRANYekanBold text-mainColor2">
                    نقش: {item?.role}
                  </p>
                  <p className="text-[15px] font-IRANYekanBold text-mainColor2">
                    اطمینان: {item?.confidence}
                  </p>
                </div>
              ))}

            {dataimage &&
              dataimage.map((item, i) => (
                <div key={i}>
                  {item?.confidence_detail?.map((item2, j) => (
                    <div key={j}>
                      <p className="text-[15px] font-IRANYekanBold text-mainColor2">
                        نام: {item2?.name}
                      </p>
                      <p className="text-[15px] font-IRANYekanBold text-mainColor2">
                        نقش: {item2?.role}
                      </p>
                      <p className="text-[15px] font-IRANYekanBold text-mainColor2">
                        اطمینان: {item2?.confidence}
                      </p>
                    </div>
                  ))}
                  <p className="text-[15px] font-IRANYekanBold text-mainColor2">
                    نام عکس: {item.img_name}
                  </p>

                  <img
                    src={`data:image/png;base64,${item?.img_base64}`}
                    className="image-message cursor-pointer"
                    alt="Base64"
                    style={{ width: "400px", height: "auto" }}
                    onClick={() => downloadImage(item?.img_base64)}
                  />
                </div>
              ))}

            {/* Inputs */}
            {type != "single_detect" && (
              <>
                <div className="mb-[21px]">
                  <div className="flex">
                    <p className="text-[15px] font-IRANYekanExtra text-mainColor2 mb-1">
                      انتخاب افراد
                    </p>
               {type!="batch_detect"? <p className="text-[#ff0000]">*</p>:null}  
                  </div>
                  <Select
                    options={persons}
                    isMulti
                    value={person}
                    onChange={handlePersonChange}
                    placeholder="انتخاب کنید"
                    styles={customStyles}
                    className="text-[12px] font-IRANYekanNormal focus:outline-lightGray border-[1px] border-borderGray rounded-[5px]"
                  />
                </div>

                <div className="flex items-center mb-[15px]">
                  <input
                    onChange={(e) => setHasImage(e.target.checked)}
                    className="w-[15px] h-[15px] accent-mainColor2"
                    type="checkbox"
                  />
                  <label className="text-[12px] font-IRANYekanMedium text-mainColor2 mr-[5px]">
                    دارای عکس
                  </label>
                </div>
              </>
            )}

            <div className="grid grid-cols-2 gap-2 w-full mt-[23px] mb-[43px]">
              <div className="col-span-1 mb-[10px] flex flex-col">
                <span className="text-[15px] font-IRANYekanBold mb-1">فایل</span>
                <PhotoUpload setFile={setFiles} />
              </div>
            </div>

            {/* Footer Buttons */}
            <div className="flex justify-center">
              <button onClick={() => setShowModal(false)}>
                <p className="text-[15px] font-IRANYekanBold ml-[23px]">بستن</p>
              </button>
              <button
                onClick={() =>
                  type != "single_detect" ? batch_detect() : editAdmin()
                }
                className="h-[40px] w-[107px] bg-Orange2 rounded-[10px]"
              >
                {snipper ? (
                  <div className="flex justify-center items-center">
                    <ClipLoader
                      color={"#000000"}
                      loading={snipper}
                      size={30}
                      aria-label="Loading Spinner"
                      data-testid="loader"
                    />
                  </div>
                ) : (
                  <p className="text-[15px] text-white font-IRANYekanBold">
                    {buttonName}
                  </p>
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Error Modal */}
        {showErrorModalStep1 && (
          <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
              <div className="relative w-[30%] lg:w-[50%] sm:w-[95%] my-5 mx-auto max-w-3xl">
                <div className="border-0 rounded-lg p-2 shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                  <div className="flex items-start justify-between p-4 border-b border-solid border-b-midGray rounded-t">
                    <span className="text-base font-bold text-red">
                      درخواست اشتباه !
                    </span>
                  </div>
                  <div className="relative px-4 py-1 flex-auto">
                    <p className="my-4 text-black text-sm leading-relaxed">
                      {error}
                    </p>
                  </div>
                  <div className="flex items-center justify-end border-solid border-slate-200 rounded-b">
                    <Link
                      className="text-white mx-4 mb-2 rounded-md shadow-blueShadow bg-Orange2 font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none ease-linear transition-all duration-150"
                      onClick={() => setShowErrorModalStep1(false)}
                    >
                      فهمیدم
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        )}
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
};

export default AddModalFace;
